import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";

export const ApprovalPendingPopup = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <UiPopup openModal={props?.isOpen} handleClose={() => {}}>
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          message={t("Approval Pending")}
          buttonText={t("Ok")}
          buttonOnClick={props?.closeModal}
          className="df-confirmation-message-popup df-btn-grpdmodal"
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p>
            <Trans
              i18nKey={t(
                "Your request is still awaiting approval. Please try again in a moment.",
              )}
            />
          </p>
          <p className=" mt-1">{t("For further assistance, please contact")}</p>

          <div className="df-onboarding-alert-customer-support">
            <a
              className="df-primary-underlined-btn df-modal-support-text"
              href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
            >
              {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
            </a>
          </div>
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
